import { __decorate, __metadata } from "tslib";
import { SerializableObject, SerializableMember, NumberType } from '../../data/decorators';
import * as THREE from './_internal';
/**
 * Serializable THREE.js Vector4
 */
let Vector4 = class Vector4 extends THREE.Vector4 {
  static fromArray(array) {
    return new this().fromArray(array);
  }
  clone() {
    return new this.constructor().copy(this);
  }
};
__decorate([SerializableMember({
  numberType: NumberType.DECIMAL
}), __metadata("design:type", Number)], Vector4.prototype, "x", void 0);
__decorate([SerializableMember({
  numberType: NumberType.DECIMAL
}), __metadata("design:type", Number)], Vector4.prototype, "y", void 0);
__decorate([SerializableMember({
  numberType: NumberType.DECIMAL
}), __metadata("design:type", Number)], Vector4.prototype, "z", void 0);
__decorate([SerializableMember({
  numberType: NumberType.DECIMAL
}), __metadata("design:type", Number)], Vector4.prototype, "w", void 0);
Vector4 = __decorate([SerializableObject()], Vector4);
export { Vector4 };